'use client';

import { c as _c } from "react/compiler-runtime";
import type { GroupMentoringProductDTO, IndividualMentoringProductDTO, ProjectMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { useWaitlistSignup } from '@/app/(marketing-site)/_components/waitlist/WaitlistSignupContext';
import { regulaminSectionHref } from '@/app/(marketing-site)/regulamin/_constants/section-hrefs';
import { MentoringOfferForm } from '../_forms/MentoringOfferForm';
import { BuyData } from '../BuyData';

// import { ScheduleAppointmentDialog } from '../ScheduleAppointmentDialog'

type PricingCardProps = {
  mentoringProduct: GroupMentoringProductDTO | IndividualMentoringProductDTO | ProjectMentoringProductDTO;
  goalPage?: boolean;
};
export function PricingCard(t0) {
  const $ = _c(15);
  const {
    mentoringProduct,
    goalPage: t1
  } = t0;
  const goalPage = t1 === undefined ? false : t1;
  const {
    open
  } = useWaitlistSignup();
  let t2;
  if ($[0] !== goalPage || $[1] !== mentoringProduct) {
    t2 = <BuyData mentoringProduct={mentoringProduct} goalPage={goalPage} />;
    $[0] = goalPage;
    $[1] = mentoringProduct;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== mentoringProduct.name || $[4] !== open) {
    t3 = <Button size="xl" className="w-full" onClick={() => open(mentoringProduct.name)}>Zapisz się na listę oczekujących</Button>;
    $[3] = mentoringProduct.name;
    $[4] = open;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button plain={true} size="xl" className="w-full" href={regulaminSectionHref("paymentRules")}>Szczegóły subskrypcji</Button>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <div className="flex w-full flex-col items-center gap-3">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== mentoringProduct) {
    t6 = <MentoringOfferForm mentoringProduct={mentoringProduct} />;
    $[9] = mentoringProduct;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t5 || $[13] !== t6) {
    t7 = <>{t2}{t5}{t6}</>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}